/* import __COLOCATED_TEMPLATE__ from './code.hbs'; */
import TwoFactorEnrollCodeComponent from '@square/ember-multipass-components/components/ember-multipass-components/two-factor/enroll/code';
export default class TwoFactorPostLoginPromoCodeComponent extends TwoFactorEnrollCodeComponent {}